import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Editor from "../../../components/admin/Editor";
import "./AddBlog.css";
import { BACKEND_URL } from "../../../config";

function AddBlog() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
  title: "",
  slug: "",
  description: "",
  metatitle: "",
  metadescription: "",
  keywords: "",
  faq: "",
  author: "",
  date: "",
  status: "published",
});

  const [file, setFile] = useState(null);

  const [imagePreview, setImagePreview] = useState(null);

  const [keywordInput, setKeywordInput] = useState("");

  const [keywordList, setKeywordList] = useState([]);

  const [faqList, setFaqList] = useState([]);

const [faqInput, setFaqInput] = useState({
  question: "",
  answer: "",
});


  const generateSlug = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  // ======================================================
  // INPUT CHANGE
  // ======================================================
  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "title") {
    setForm((prev) => ({
      ...prev,
      title: value,
      slug: generateSlug(value),
    }));
  } else {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};



  // ======================================================
  // KEYWORDS
  // ======================================================
  const handleKeywordKeyDown = (e) => {

    if (e.key === "," || e.key === "Enter") {

      e.preventDefault();

      const value = keywordInput.trim();

      if (value && !keywordList.includes(value)) {

        setKeywordList([...keywordList, value]);
      }

      setKeywordInput("");
    }
  };



  // ======================================================
  // REMOVE KEYWORD
  // ======================================================
  const removeKeyword = (index) => {

    setKeywordList(
      keywordList.filter((_, i) => i !== index)
    );
  };

  const handleFaqInputChange = (field, value) => {

  setFaqInput((prev) => ({
    ...prev,
    [field]: value,
  }));

};

const addFaq = () => {

  const question = faqInput.question.trim();
  const answer = faqInput.answer.trim();

  if (!question || !answer) {
    alert("Please enter Question & Answer");
    return;
  }

  setFaqList([
    ...faqList,
    {
      question,
      answer,
    },
  ]);

  setFaqInput({
    question: "",
    answer: "",
  });

};

const removeFaq = (index) => {

  setFaqList(
    faqList.filter((_, i) => i !== index)
  );

};


  // ======================================================
  // IMAGE
  // ======================================================
  const handleImage = (e) => {

    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    // ONLY WEBP
    if (selectedFile.type !== "image/webp") {

      alert("Only WEBP images allowed ");

      return;
    }

    setFile(selectedFile);

    setImagePreview(
      URL.createObjectURL(selectedFile)
    );
  };



  // ======================================================
  // SUBMIT
  // ======================================================
  const handleSubmit = async (status = "published") => {

  try {

    const formData = new FormData();

    formData.append("action","add");

    formData.append("title",form.title);
    formData.append("slug",form.slug);
    formData.append("description",form.description);
    formData.append("metatitle",form.metatitle);
    formData.append("metadescription",form.metadescription);
    formData.append("keywords",keywordList.join(","));
    formData.append(
      "faq",
      JSON.stringify(faqList)
    );
    formData.append("author",form.author);
    formData.append("date",form.date);
    formData.append("status",status);

    if(file){
      formData.append("image",file);
    }

    const response = await fetch(
      `${BACKEND_URL}/api.php?module=blog`,
      {
        method:"POST",
        body:formData,
      }
    );

    const result = await response.json();

    if(result.success){

      alert(
        status==="draft"
        ? "Draft Saved Successfully"
        : "Blog Published Successfully"
      );

      navigate("/admin/blog");

    }else{

      alert(result.message);

    }

  }catch(err){

    console.log(err);
    alert("Backend Error");

  }

};



  return (

    <div className="add-blog-page">

      <h2 className="page-title">
        Add Blog
      </h2>

      <form
          className="blog-form"
          onSubmit={(e)=>{
          e.preventDefault();
          handleSubmit("published");
          }}
          >

        {/* TITLE */}
        <h3>Title</h3>

        <input
          name="title"
          value={form.title}
          onChange={handleChange}
        />
    

        <h3>Slug</h3>

        <input
          name="slug"
          value={form.slug}
          onChange={handleChange}
        />

        {/* DESCRIPTION */}
        <h3>Description</h3>

        <Editor
          formData={form}
          setFormData={setForm}
          field="description"
        />



        {/* META TITLE */}
        <h3>Meta Title</h3>

        <input
          name="metatitle"
          value={form.metatitle}
          onChange={handleChange}
        />



        {/* META DESCRIPTION */}
        <h3>Meta Description</h3>

        <textarea
          name="metadescription"
          value={form.metadescription}
          onChange={handleChange}
        />



        {/* KEYWORDS */}
        <h3>Keywords</h3>

        <input
          value={keywordInput}
          onChange={(e) =>
            setKeywordInput(e.target.value)
          }

          onKeyDown={handleKeywordKeyDown}

          placeholder="keyword + Enter"
        />


        <div className="keyword-box">

          {keywordList.map((k, i) => (

            <span
              key={i}
              className="keyword-tag"
              onClick={() => removeKeyword(i)}
            >
              {k} ✖
            </span>
          ))}
        </div>


         {/* FAQ */}

            {/* FAQ */}

        <div>

          <h3>FAQ</h3>

          {/* SAVED / LOCKED FAQs - jaise keyword tag */}

          {faqList.map((item, index) => (

            <div className="faq-box-page" key={index}>

              <strong>Q: {item.question}</strong>

              <span>A: {item.answer}</span>

              <button
                type="button"
                className="remove-btn"
                onClick={() =>
                  removeFaq(index)
                }
              >
                Remove
              </button>

            </div>
          ))}

          {/* ACTIVE INPUT - sirf ek hi pair, jaise keyword input */}

          <div className="faq-box-page">

            <input
              placeholder="Question"
              value={faqInput.question}
              onChange={(e) =>
                handleFaqInputChange(
                  "question",
                  e.target.value
                )
              }
            />

            <input
              placeholder="Answer"
              value={faqInput.answer}
              onChange={(e) =>
                handleFaqInputChange(
                  "answer",
                  e.target.value
                )
              }
            />

          </div>

          <button
            type="button"
            onClick={addFaq}
          >
            + Add FAQ
          </button>

        </div>

        {/* AUTHOR */}
        <h3>Author</h3>

        <input
          name="author"
          value={form.author}
          onChange={handleChange}
        />



        {/* DATE */}
        <h3>Date</h3>

        <input
          type="date"
          name="date"
          value={form.date}
          onChange={handleChange}
        />



        {/* IMAGE */}
        <h3>Image (WEBP Only)</h3>

        <input
          type="file"
          accept=".webp,image/webp"
          onChange={handleImage}
        />



        {/* PREVIEW */}
        {imagePreview && (

          <img
            src={imagePreview}
            width="200"
            alt=""
            style={{
              marginTop: "10px",
            }}
          />
        )}



        {/* BUTTON */}
        <div className="blog-buttons">

            <button
                type="button"
                className="draft-btn"
                onClick={() => handleSubmit("draft")}
            >
                Save Draft
            </button>

            <button
                type="submit"
                className="publish-btn"
            >
                Publish Blog
            </button>

        </div>
      </form>
    </div>
  );
}

export default AddBlog;